import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'pg-lib/services/environment.service';
import { GoogleMapsService } from 'pg-lib/services/google-maps.service';

@Component({
    selector: 'app-totem-background-map',
    templateUrl: './totem-background-map.component.html',
    styleUrls: ['./totem-background-map.component.scss'],
    standalone: false
})
export class TotemBackgroundMapComponent implements OnInit, OnChanges {

    constructor(private environmentService:EnvironmentService, private http:HttpClient, private googleMapsService:GoogleMapsService) { }

    @Input() location:string;
    @Input() coordinates:{ lat: number, lon: number };

    imgSrc:string = null;

    mapVisible = false;

    ngOnInit(): void {
    }

    @ViewChild('gmaps', { static: true }) gmapsElement: ElementRef;

    ngOnChanges(simpleChanges) {
        this.imgSrc = null;
        this.mapVisible = false;

        if(simpleChanges.location) {
            if(this.location != null) {
                this.imgSrc = this._getMapUrl(this.location)
            }
        }

        if(simpleChanges.coordinates) {
            if(this.coordinates != null) {
                this.googleMapsService.loadMaps().then(() => {
                    this.mapVisible = true;

                    this.http.get('assets/background-map-style.json').subscribe((data:any) => {
                        let _map = new google.maps.Map(this.gmapsElement.nativeElement, {
                            center: new google.maps.LatLng(0, 0),
                            zoom: 1,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                            disableDefaultUI: true,
                            keyboardShortcuts: false,
                            clickableIcons: false,
                            gestureHandling: 'none',
                            styles: data        
                        })
    
                        _map.setZoom(14)
                        _map.setCenter({ lat: this.coordinates.lat, lng: this.coordinates.lon })
                    })
                }, () => {
                    this.imgSrc = this._getMapUrl(this.coordinates.lat + ',' + this.coordinates.lon)                    
                })
            }
        }
    }

    private _getMapUrl(center:string) {
        if(center != '') {
            let _styleString = 'style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels%7Cvisibility:off&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Cvisibility:off&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:administrative.neighborhood%7Cvisibility:off&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e'

            // questo stringone è preso da https://mapstyle.withgoogle.com/
            // slider labels a 0, theme silver

            return 'https://maps.googleapis.com/maps/api/staticmap?' +
                //'maptype=hybrid&' +
                'size=640x640&' +
                'scale=2&' +
                'zoom=13&' +
                'center=' + encodeURIComponent(center) + '&' +
                _styleString +
                '&key=' + this.environmentService.environment.GoogleMapsAPIKey        
        }
    }
}
